<app-euds-nav-container *ngIf="!showSearchAccount" [skipNavigation]="true" (navBack)="onBackClick()">
  <style>
    .nav-single-line {
      margin-top: 0.75rem;
    }
  </style>
  <div class="nav-single-line">Account #{{searchAccountNumber}}</div>
</app-euds-nav-container>
<h2>Real-Time Preview</h2>
<div class="preview-search-controls" *ngIf="showSearchAccount">
  <app-euds-textfilter label="Account Number"
                       class="preview-search-input"
                       [showResultMessage]="false"
                       [(ngModel)]="searchAccountNumber">
  </app-euds-textfilter>
  <div class="preview-search-button-bar">
    <app-euds-button type="primary"
                     label="Search"
                     [disabled]="isLoading"
                     (clickEvent)="doSearch()">
    </app-euds-button>
    <app-euds-button type="secondary"
                     label="Clear Search"
                     (clickEvent)="clearSearch()"></app-euds-button>
  </div>
</div>
<ng-container *ngIf="!showSearchAccount">
  <app-euds-card *ngIf="!isPHI()" elevation="md" padding="md" display="block" additionalStyleClass="real-time-preview-card">
    <app-euds-tag label="CX Wrapper View" class="view-label"></app-euds-tag>
  <app-customer-alert-cxw *ngIf="fetchedSummary"
                          [summary]="fetchedSummary"
                          [opCo]="opCoSelected"
                          [feedbackDisabled]="feedbackDisabled"
                          [feedbackState]="feedbackState"
                          (feedbackChange)="onFeedbackChange($event)">
  </app-customer-alert-cxw>
  <app-customer-alert-cxw *ngIf="!fetchedSummary" [opCo]="opCoSelected"></app-customer-alert-cxw>
  </app-euds-card>
  <app-euds-card *ngIf="isPHI()" elevation="md" padding="md" display="block" additionalStyleClass="real-time-preview-card">
    <app-euds-tag label="CIS 360 View" class="view-label"></app-euds-tag>
  <app-customer-alert-sap *ngIf="fetchedSummary"
                          [summary]="fetchedSummary"
                          [opCo]="opCoSelected"
                          [feedbackDisabled]="feedbackDisabled"
                          [feedbackState]="feedbackState"
                          (feedbackChange)="onFeedbackChange($event)">
  </app-customer-alert-sap>
  <app-customer-alert-sap *ngIf="!fetchedSummary" [opCo]="opCoSelected"></app-customer-alert-sap>

  </app-euds-card>
</ng-container>
<app-euds-loader [visible]="isLoading"></app-euds-loader>
